
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  watch
} from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'primevue/usetoast'
import router from '@/router'
import { useCurrentTime } from '../pages/useCurrentTime'

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },

  setup() {
    const store = useStore()
    const toast = useToast()

    /* 🔔 WATCH TOKEN – CỰC KỲ QUAN TRỌNG */

    let notificationTimer: number | null = null

    const startNotificationPolling = () => {
      stopNotificationPolling()
      notificationTimer = window.setInterval(() => {
        store.dispatch('fetchNotification')
      }, 30000) // 30 giây
    }

    const stopNotificationPolling = () => {
      if (notificationTimer) {
        clearInterval(notificationTimer)
        notificationTimer = null
      }
    }
    watch(
        () => store.state.token,
        (newToken) => {
          if (newToken) {
            store.dispatch('fetchNotification')
            startNotificationPolling()
          } else {
            stopNotificationPolling()
          }
        },
        { immediate: true }
    )

    onBeforeUnmount(() => {
      stopNotificationPolling()
    })

    /* ===== PERMISSION ===== */
    const permission = computed(() => {
      return !!store.state.token && store.state.permission === 'admin'
    })

    /* ===== BADGE TEXT (TỪ VUEX) ===== */
    const badgeText = computed(() => {
      const count = store.getters.notificationCount
      if (count <= 0) return ''
      return count > 9 ? '9+' : count
    })

    /* ===== MENU SCROLL / SWIPE ===== */
    const menuSwipe = ref<HTMLElement | null>(null)

    onMounted(() => {
      const el = menuSwipe.value
      if (!el) return

      let startX = 0
      let startY = 0
      let isDragging = false
      const SPEED = 1

      const onTouchStart = (e: TouchEvent) => {
        startX = e.touches[0].clientX
        startY = e.touches[0].clientY
        isDragging = false
      }

      const onTouchMove = (e: TouchEvent) => {
        if (!el) return

        const dx = e.touches[0].clientX - startX
        const dy = e.touches[0].clientY - startY

        if (!isDragging && Math.abs(dx) > Math.abs(dy)) {
          isDragging = true
        }

        if (isDragging) {
          e.preventDefault()
          el.scrollLeft -= dx * SPEED
          startX = e.touches[0].clientX
        }
      }

      const onWheel = (e: WheelEvent) => {
        if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
          e.preventDefault()
          el.scrollLeft += e.deltaY
        }
      }

      el.addEventListener('touchstart', onTouchStart, { passive: true })
      el.addEventListener('touchmove', onTouchMove, { passive: false })
      el.addEventListener('wheel', onWheel, { passive: false })

      onBeforeUnmount(() => {
        el.removeEventListener('touchstart', onTouchStart)
        el.removeEventListener('touchmove', onTouchMove)
        el.removeEventListener('wheel', onWheel)
      })
    })

    /* ===== LOGOUT ===== */
    const logout = () => {
      store.dispatch('clearToken')
      store.dispatch('clearPermission')
      store.dispatch('cleanDailyPopupShown')
      router.push({ name: 'login' })
    }

    const { currentTime, formatTimeVN } = useCurrentTime()

    return {
      permission,
      badgeText,
      menuSwipe,
      logout,
      currentTime,
      formatTimeVN
    }
  }
}
